module.exports = __webpack_public_path__ + "static/assets/1e423b0820f29e303c329a51cfe5c73d.png";